import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IGetInput,
    IGetResponse,
    ISupporterChatMessagesClient,
} from 'interfaceAdapter/gatewaySchemas/ISupporterChatMessagesClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class SupporterChatMessagesClient implements ISupporterChatMessagesClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token, chatRoomId } = input;

        const PATH = `${API_LOCATION_URL}/supporter/chat_messages?chat_room_id=${chatRoomId}`;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-S': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}

